import * as echarts from "echarts";
import { useEffect, useRef } from "react";

import { IAnalyzeState } from "../types";
// import useEchartResizer from "./useEchartResizer";

interface IProps {
    pieData: IAnalyzeState[] | undefined;
    category: string;
}

const usePieChart = ({ category, pieData }: IProps) => {
    const MPieChart = useRef(null);
    // useEchartResizer({ ref: MPieChart });

    useEffect(() => {
        const pieChart = echarts.init(MPieChart.current);

        // 計算總數以用於百分比計算
        const totalValue = pieData?.reduce((sum, item) => sum + item.value, 0) || 0;

        const option = {
            title: {
                text: category,
                left: "left",
            },
            grid: {
                top: "2%",
                left: "2%",
                right: "2%",
                bottom: "2%",
                containLabel: true,
            },
            color: ["#59344F", "#F6D47D", "#99B1DD", "#E1B6A3", "#50F1DD", "#C984FF", "#5FCA88"],
            label: {
                fontSize: 16,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: { seriesName: string; name: string; value: number }) => {
                    const percentage = totalValue > 0 ? ((params.value / totalValue) * 100).toFixed(1) : "0.0";
                    return `${params.name}: ${percentage}%`;
                },
            },
            itemStyle: {
                borderRadius: 2,
            },
            series: [
                {
                    name: category,
                    startAngle: 90,
                    type: "pie",
                    radius: "77%",
                    data: pieData,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 20,
                            shadowOffsetX: 0,
                            borderRadius: 5,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        };
        pieChart.setOption(option);
        return () => {
            pieChart.dispose();
        };
    }, [category, pieData]);

    return MPieChart;
};

export default usePieChart;
